import type { Company, UserProfile } from '@/types';
import { isProd } from '@/utils/helpers';

export const appcuesSetup = (userProfile: UserProfile, company: Company) => {
  if (isProd && typeof Appcues !== 'undefined') {
    const { company_schema_name, id, email, full_name } = userProfile;
    const { is_free_tier } = company;

    Appcues.identify(id, { company_schema_name, email, full_name, is_free_tier });
  }
};
